import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bold" }
const _hoisted_3 = {
  key: 0,
  class: "bold"
}
const _hoisted_4 = {
  key: 1,
  class: "font-weight-bold pb-2"
}
const _hoisted_5 = {
  key: 2,
  class: "row activities"
}
const _hoisted_6 = { class: "badge badge-pill" }
const _hoisted_7 = { class: "badge badge-pill" }
const _hoisted_8 = { class: "badge badge-pill" }
const _hoisted_9 = { class: "badge badge-pill" }
const _hoisted_10 = { class: "badge badge-pill" }
const _hoisted_11 = { class: "badge badge-pill" }
const _hoisted_12 = { class: "badge badge-pill" }
const _hoisted_13 = { class: "badge badge-pill" }

import {computed, onMounted, PropType, ref} from "vue";
import {Me} from "@/store/i/types";
import {useStore} from "vuex";
import {getmyranking} from "@/crud";


export default /*@__PURE__*/_defineComponent({
  __name: 'MyRanking',
  props: {
  me: {
    type: Object as PropType<Me>,
    required: true,
  }
},
  setup(__props) {

const props = __props;

const store = useStore();

const MyPoints = computed(() => {
  return store.getters['i/myPoints'];
});

const MyRank = ref(0);

onMounted(async () => {
  if(props.me?.objvalueid > 0) {
    MyRank.value = await getmyranking(props.me.objvalueid);
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.me.tn_type != 26 && __props.me.tn_type != 33 && __props.me.tn_type != 37)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, " Your XP: " + _toDisplayString(MyPoints.value), 1),
        (MyRank.value > 0 && MyRank.value > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Your position: " + _toDisplayString(MyRank.value), 1))
          : _createCommentVNode("", true),
        (__props.me.tn_type != 26 || __props.me.tn_type != 33 ||  __props.me.tn_type != 37)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_4, " Activities to earn XP: "))
          : _createCommentVNode("", true),
        (__props.me.tn_type != 26 || __props.me.tn_type != 33 ||  __props.me.tn_type != 37)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_e >= 5), 'notDone':(__props.me.ranking_e < 5)}])
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "far fa-gamepad-modern fa-2x" }, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(__props.me.ranking_e), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_a + __props.me.ranking_c >= 300), 'notDone':(__props.me.ranking_a + __props.me.ranking_c < 300)}])
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "far fa-comment-alt fa-2x" }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.me.ranking_a + __props.me.ranking_c), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_g >= 200), 'notDone':(__props.me.ranking_g < 200)}])
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "far fa-video fa-2x" }, null, -1)),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(__props.me.ranking_g), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_d >= 25), 'notDone':(__props.me.ranking_d < 25)}])
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "far fa-user-friends fa-2x" }, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(__props.me.ranking_d), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_f >= 25), 'notDone':(__props.me.ranking_f < 25)}])
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "far fa-calendar-alt fa-2x" }, null, -1)),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(__props.me.ranking_f), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_b >= 35), 'notDone':(__props.me.ranking_b < 35)}])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "far fa-calendar-star fa-2x" }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.me.ranking_b), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_m + __props.me.ranking_l + __props.me.ranking_k >= 17), 'notDone':(__props.me.ranking_m + __props.me.ranking_l + __props.me.ranking_k < 17)}])
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "far fa-user-circle fa-2x" }, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_12, _toDisplayString(__props.me.ranking_m + __props.me.ranking_l + __props.me.ranking_k), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col text-center", {'alreadyDone':(__props.me.ranking_i + __props.me.ranking_j >= 8), 'notDone':(__props.me.ranking_i + __props.me.ranking_j < 8)}])
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "far fa-door-open fa-2x" }, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(__props.me.ranking_i + __props.me.ranking_j), 1)
              ], 2),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-4" }, null, -1))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})